module.exports = __webpack_public_path__ + "img/image 7.d1cb6d08.png";